import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { routes } from '~/routes';
import { useRequireSignUpStep } from '../shared/useRequireSignUpStep';
import { SignUpStepWrapper } from '../shared/SignUpStepWrapper';
import { OfficeDetailsForm } from './OfficeDetailsForm';

export const OfficeDetailsPage = () => {
  useRequireSignUpStep();

  return (
    <SignUpStepWrapper
      step={2}
      backTo={routes.signUpRedesign.yourInfo}
      title="Let’s Find Professionals Near You"
      subtitle={
        <>
          GoTu is trusted by{' '}
          <Typography as="span" bold color={colors.primary[500]} style={{ fontSize: 18 }}>
            200K+ dental professionals
          </Typography>
          . Tell us where you are to see who’s nearby.
        </>
      }
    >
      <OfficeDetailsForm />
    </SignUpStepWrapper>
  );
};
